<template>
    <div class="app-tag">
        <el-tabs type="card">
        <el-tag 
            closable 
            size="medium" 
            v-for="(tag, index) in stateTagsList" 
            :key="tag.menuName"
            type='info'
            :class="curTags.menuUrl == tag.menuUrl? 'plain-css':''"
            disable-transitions
            :effect="curTags.menuUrl == tag.menuUrl? 'plain':'plain'" 
            @close="handleClose(tag,index)" 
            @click="handleClick(tag)">
                {{tag.menuName}}
        </el-tag>
        </el-tabs>
    </div>
</template>
<script>
import { mapState,mapMutations } from 'vuex';
export default {
    name: 'app-tag',
    data() {
        return {
            tags: [],
        }
    },
    created() {
    //stateTagsList是state.js中的存放tags数组的key，stateTagsList的值默认为空数组
        this.tags = this.stateTagsList
    },
    computed: {
        ...mapState(['curTags','stateTagsList'])
    },
    methods: {
        ...mapMutations({
            close: 'mutationCloseTag'
        }),
        handleClose(tag, index) {
            if (this.stateTagsList.length <= 1) { // 如果只有一个标签则不能关闭
                return
            }
            this.close(tag) // 删除当前tag
            // if (this.curTags.menuUrl === tag.menuUrl) { // 如果关闭的标签不是当前路由的话，不做路由跳转
            //     return
            // } else {
            // if (index === (this.tags.length - 1)) { // 关闭最后一个标签,则路由跳转至最后一个
            //     this.$router.push(this.stateTagsList[index].menuUrl)
            // } else { // 路由跳转至下一个标签页
            //     if(index===0){
            //         this.$router.push(this.stateTagsList[0].menuUrl)
            //     }else{
            //         this.$router.push(this.stateTagsList[index - 1].menuUrl)
            //     }
            // }
            this.$router.push(this.stateTagsList[this.stateTagsList.length - 1].menuUrl)
            this.$store.commit('checkedTags', this.stateTagsList[this.stateTagsList.length - 1])
            // }
        },
        // 点击tags具体标签
        handleClick(tag) {
            this.$store.commit('checkedTags', tag)
            this.$router.push(tag.menuUrl)
        }
    }
}
</script>
<style scoped>
.el-tag {
    padding: 0 16px;
    border-radius: 0px;
    font-size: 14px;
    
    padding:0 12px;
}
.el-tag--medium {
    height: 40px;
    line-height: 40px;
}
.el-tabs[data-v-9331e7c6] {
    padding: 0 12px!important;
}
.el-tabs {
    background-color: #F2F6FC !important;
    border-bottom: 1px solid #ccc!important;
}
.el-tabs--top > .el-tabs__content {
    background-color: #F2F6FC !important;
    border-left: 1px solid #ccc !important;
}
.el-tag--plain {
    border: 0px !important;
    background-color: #F2F6FC !important;
    border-right: 1px solid #ccc !important;
}
.plain-css {
    background-color: #fff !important;
    border-right: 1px solid #ccc;
    border-bottom: none;
}
</style>


// WEBPACK FOOTER //
// src/components/common/apptag.vue